import { message, Modal, Spin } from 'antd';
import { Formik } from 'formik';
import { Input } from 'formik-antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DateComponent from '~/components/DateComponent';
import FormControl from '~/components/Form/FormControl';
import InputCurrency from '~/components/Form/InputCurrency';
import { ModalFooter } from '~/components/Modal';
import { createExtraExpenses, updateExtraExpenses } from '~/services/hooks/extraExpenses';
import { useCheckAuth } from '~/components/Can/checkAuth';
import Row from '~/components/Row';
import errorHandler from '~/Utils/errorHandler';

const initial = {
  name: '',
  description: '',
  price: '',
  acquired_at: '',
};

export default function ExtraExpensesModal({ visible, onClose, extraExpensesEdit, isMobile }) {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initial);

  const handleSave = async (values, { setErrors }) => {
    setLoading(true);
    try {
      if (extraExpensesEdit?.id) {
        await updateExtraExpenses(extraExpensesEdit.id, values);
        message.success(t('Despesa atualizada'));
      } else {
        await createExtraExpenses(values);
        message.success(t('Despesa criada'));
      }
      onClose();
    } catch (error) {
      console.error(error);
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  const fluidPermissions = () => {
    if (extraExpensesEdit) {
      return authCheck('@extraExpenses/edit');
    } else {
      return authCheck('@extraExpenses/create');
    }
  };

  useEffect(() => {
    if (visible) {
      if (extraExpensesEdit) {
        setInitialValues(extraExpensesEdit);
      }
    }
  }, [visible]);

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSave}
    >
      {({ isSubmitting, submitForm, setFieldValue, values }) => (
        <Modal
          title={
            (extraExpensesEdit ? t('Editando despesa extra - ') : t('Criando despesa extra - ')) +
            (extraExpensesEdit?.name ?? '')
          }
          onCancel={onClose}
          afterClose={() => setInitialValues(initial)}
          open={visible}
          centered
          width={isMobile ? '100%' : '800px'}
          footer={<ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} />}
        >
          <Spin spinning={loading}>
            <Row>
              <FormControl cols={{ sm: 8, xs: 24 }} label={t('fields:extraExpenses.name')} name="name">
                <Input name="name" placeholder={t('Nome')} disabled={!fluidPermissions()} />
              </FormControl>
              <FormControl cols={{ sm: 8, xs: 12 }} label={t('fields:extraExpenses.price')} name="price">
                <InputCurrency name="price" placeholder={t('Valor')} disabled={!fluidPermissions()} />
              </FormControl>
              <FormControl cols={{ sm: 8, xs: 12 }} label={t('fields:extraExpenses.acquiredAt')} name="acquired_at">
                <DateComponent
                  value={values.acquired_at}
                  onChange={(date) => setFieldValue('acquired_at', date)}
                  disabled={!fluidPermissions()}
                />
              </FormControl>
            </Row>
            <Row>
              <FormControl cols={{ xs: 24 }} label={t('fields:extraExpenses.description')} name="description">
                <Input.TextArea
                  name="description"
                  placeholder={t('screens:default.description')}
                  disabled={!fluidPermissions()}
                />
              </FormControl>
            </Row>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
